import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Button from '../../UniformComponents/Button'
import Modal from '../../UniformComponents/Modal'
import FormController from '../form/FormController'
import InfoAccordion from '../InfoAccordion'
import RecordTag from '../RecordTags'
import SearchIcon from '../../assets/images/portfolio_search_icon.svg'
import FolderIcon from '../../assets/images/portfolio_openfolder.svg'

@observer
class DivisionEdit extends Component {
    constructor(props) {
        super(props)
        this.fields = {}
        this.state = {
            isPortfolioAccordionOpen: false,
            isGuidanceAccordionOpen: true,
        }
    }

    areRecordTagsValid = () => this.fields.recordTag.validate()

    areFieldsValid = () => {
        const { divisionStore } = this.props
        return this.fields.divisionName({
            value: divisionStore.divisionName,
            name: 'divisionName',
        }, true)
    }

    register = (name, validate, path) => {
        this.fields[name] = {
            validate,
            path,
        }
    }

    unregister = (name) => {
        Reflect.deleteProperty(this.fields, name)
    }

    isValid = () => (
        Object.values(this.fields).every(({ validate }) => (
            validate()
        ))
    )

    save = async () => {
        const {
            store, divisionId, divisionStore, handleCloseModal,
        } = this.props

        const fieldsValid = this.areFieldsValid()
        const recordTagsValid = this.areRecordTagsValid()
        if (!fieldsValid || !recordTagsValid) return

        const isEditing = divisionId !== 0

        try {
            if (isEditing) {
                await divisionStore.update({
                    divisionId: parseInt(divisionId, 10),
                    name: divisionStore.divisionName,
                })
            } else {
                await divisionStore.save({
                    kind: 'NewDivisionRequest',
                    name: divisionStore.divisionName,
                    divisionUser: {},
                })
            }
            divisionStore.saveTags(divisionId)
            handleCloseModal(divisionId)
            await divisionStore.initSearch()
            store.addNotification(null, `${isEditing ? i18n.t('update_division') : i18n.t('create_division')}`, 'success')
        } catch (e) {
            console.log(e)
            store.addNotification(null, `Error ${isEditing ? 'updating' : 'creating'} divison`, 'error')
        }
    }

    renderButtons = () => {
        const { handleCloseModal } = this.props
        return (
            <div className="form-button-wrapper">
                <Button
                    label={i18n.t('close')}
                    cssClass="regular tertiary"
                    onClick={handleCloseModal}
                />
                <Button
                    label={i18n.t('save')}
                    icon="fa-light fa-floppy-disk"
                    cssClass="regular primary"
                    onClick={this.save}
                />
            </div>
        )
    }

    renderPortfolioAccordion = () => {
        const { divisionStore, divisionId } = this.props
        const { isPortfolioAccordionOpen } = this.state
        if (divisionId === 0 || !divisionStore.portfolios?.length) return null
        return (
            <InfoAccordion
                title={i18n.t('divisionEdit.accordion.portfolios')}
                show={isPortfolioAccordionOpen}
                toggle={this.togglePortfolioAccordion}
            >
                {divisionStore.portfolios.map((portfolio) => (
                    <p>{portfolio.name}</p>
                ))}
            </InfoAccordion>
        )
    }

    togglePortfolioAccordion = () => {
        this.setState((prevState) => ({
            isPortfolioAccordionOpen: !prevState.isPortfolioAccordionOpen,
        }))
    }

    renderGuidanceAccordion = () => {
        const { isGuidanceAccordionOpen } = this.state
        return (
            <InfoAccordion
                title={i18n.t('divisionEdit.accordion.guidance.title')}
                show={isGuidanceAccordionOpen}
                toggle={this.toggleGuidanceAccordion}
                cssClass="mb-35"
                infoContentClass="p-8"
            >
                <div className="card-wrapper bg-white">
                    <div className="card">
                        <img src={SearchIcon} alt="magnifying glass icon" />
                        <div>
                            <p className="subtitle">{i18n.t('portfolioDivisionEdit.accordion.guiance.step.1')}</p>
                            <div dangerouslySetInnerHTML={{
                                __html: i18n.t('divisionEdit.accordion.guidance.desc.1.1'),
                            }}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: i18n.t('divisionEdit.accordion.guidance.desc.1.2'),
                            }}
                            />
                        </div>
                    </div>
                    <div className="card">
                        <img src={FolderIcon} alt="open folder icon" />
                        <div>
                            <p className="subtitle">{i18n.t('portfolioDivisionEdit.accordion.guiance.step.2')}</p>
                            <div dangerouslySetInnerHTML={{
                                __html: i18n.t('portfolioDivisionEdit.accordion.guidance.desc.2.1'),
                            }}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: i18n.t('divisionEdit.accordion.guidance.desc.2.2'),
                            }}
                            />
                        </div>
                    </div>
                </div>
            </InfoAccordion>
        )
    }

    toggleGuidanceAccordion = () => {
        this.setState((prevState) => ({
            isGuidanceAccordionOpen: !prevState.isGuidanceAccordionOpen,
        }))
    }

    render() {
        const {
            showModal, handleCloseModal, divisionStore, divisionId,
        } = this.props
        return (
            <Modal show={showModal} onClose={handleCloseModal} loading={divisionStore.formLoading}>
                <div className="form-header">
                    <h2>{divisionId !== 0 ? i18n.t('edit_division') : i18n.t('add_division')}</h2>
                    <p className="desc">
                        {divisionId !== 0 ? i18n.t('edit_division_desc') : i18n.t('add_division_desc')}
                    </p>
                </div>
                {this.renderGuidanceAccordion()}
                <FormController
                    fields={this.fields}
                    formFields={divisionStore.formFields}
                    setField={divisionStore.setField}
                />
                <br />
                <br />
                <RecordTag
                    values={divisionStore.recordTags}
                    availableTags={divisionStore.availableTags}
                    onBlur={divisionStore.setTag}
                    register={this.register}
                    unregister={this.unregister}
                />
                <br />
                {this.renderPortfolioAccordion()}
                {this.renderButtons()}
            </Modal>
        )
    }
}

export default DivisionEdit
